import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COMMS_STACK_PETITION_SIGNER_REENGAGEMENT_RECOMMENDATIONS_ENABLED = createFcmDetails(
	'comms_stack_petition_signer_reengagement_recommendations_enabled',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		import: false,
		description:
			'Enables collation service recommendations lookup for petition_signer_reengagement message in comms stack.',
	},
);
